import React from 'react';
import '../../styles/components/lists/TriviaVerticalList.css';

export function TriviaVerticalList({children, className}) {
    return (
        <div className={`trivia-horizontal-list ${className}`}>
            {children}
        </div>
    )
}